<template>
  <div class="spacer">
    <div class="stat-item">
      <el-button
          @click="showManagementDialog"
          class="management-btn"
          style="width: 100%; height: 70px; font-size: 18px; font-weight: bold; border-radius: 15px; display: flex; align-items: center; justify-content: center;">
        管理
      </el-button>
    </div>
    <div class="stat-item">
      <el-button
          @click="showLuckyDrawDialog"
          type="primary"
          class="lucky-draw-btn"
          style="width: 100%; height: 70px; font-size: 18px; font-weight: bold; border-radius: 15px; display: flex; align-items: center; justify-content: center;">
        点名
      </el-button>
    </div>
    
    <div class="qr-code-container">
      <div class="qr-code-wrapper">
        <canvas ref="qrCodeCanvas" class="qr-code"></canvas>
      </div>
      <div class="qr-code-text">扫码进入移动端</div>
    </div>
    
    <!-- 管理弹窗 -->
    <ManagementDialog
      :visible.sync="localManagementDialogVisible"
      :classId="classId"
      :subjectIndex="subjectIndex"
      @management-closed="handleManagementClosed"
    />
    
    <!-- 点名转盘弹窗 -->
    <LuckyDrawDialog
      :visible.sync="localLuckyDrawDialogVisible"
      :students="students"
      :subject-index="subjectIndex" />
  </div>
</template>

<script>
import ManagementDialog from './ManagementDialog.vue'
import LuckyDrawDialog from './LuckyDrawDialog.vue'
import QRCode from 'qrcode'

export default {
  name: 'Spacer',
  components: {
    ManagementDialog,
    LuckyDrawDialog
  },
  props: {
    classId: {
      type: Number,
      default: null
    },
    subjectIndex: {
      type: Number,
      default: 0
    },
    students: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localManagementDialogVisible: false,
      localLuckyDrawDialogVisible: false
    }
  },
  mounted() {
    this.generateQRCode();
  },
  methods: {
    showManagementDialog() {
      this.localManagementDialogVisible = true;
    },
    showLuckyDrawDialog() {
      this.localLuckyDrawDialogVisible = true;
    },
    handleManagementClosed() {
      console.log('[Spacer] 管理界面已关闭，刷新页面');
      window.location.reload();
    },
    generateQRCode() {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port;
      
      let baseUrl = `${protocol}//${hostname}`;
      if (port && port !== '80' && port !== '443') {
        baseUrl += `:${port}`;
      }
      
      const canvas = this.$refs.qrCodeCanvas;
      if (canvas) {
        QRCode.toCanvas(canvas, baseUrl, {
          width: 150,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        }, function(error) {
          if (error) {
            console.error('生成二维码失败:', error);
          }
        });
      }
    }
  }
}
</script>

<style scoped>
/* 引入全局样式以确保spacer正确显示 */
@import '../../assets/styles/index.css';

.lucky-draw-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.lucky-draw-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(40, 167, 69, 0.3);
  filter: brightness(1.1);
}

.lucky-draw-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  filter: brightness(0.95);
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 16px;
  width: 110px;
  aspect-ratio: 1/1;
}

.qr-code-wrapper {
  padding: 8px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
}

.qr-code {
  display: block;
  max-width: 110px;
  max-height: 110px;
  padding: 0;
}

.qr-code-text {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
